const PanelistData = (state = {}, action) => {
    switch (action.type) {
        case 'SESSIONS_POPULATED' : 
            return{
            ...state,
            sessionsData : action.payload
            }
        default:
            return state
        }
  }
  export default PanelistData